import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDC08hx20ITTEV94xr_mIknyEnoIYDbD2U',
  authDomain: 'absolut-skin.firebaseapp.com',
  projectId: 'absolut-skin',
  storageBucket: 'absolut-skin.firebasestorage.app',
  messagingSenderId: '898767385758',
  appId: '1:898767385758:web:bd87ae53b99b61ecaf378f',
  measurementId: 'G-CJCJ752S17',
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}

export default firebase;
